import { call, put, takeLatest } from 'redux-saga/effects';

import { PersonalAccidentQuoteApi } from '@apis/PersonalAccidentQuoteApi';
import { PersonalAccidentQuote } from '@models/PersonalAccidentQuote';
import { SagaPayload } from '@utils/typescript';

import {
  personalAccidentQuoteFind,
  PersonalAccidentQuoteFindPayload,
  personalAccidentQuoteSendEmail,
  PersonalAccidentQuoteSendEmailPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handlePersonalAccidentQuoteFind({ payload }: SagaPayload<PersonalAccidentQuoteFindPayload>) {
  const state: StateUpdatePayload = { personalAccidentQuote: null };
  try {
    state.personalAccidentQuote = (yield call(PersonalAccidentQuoteApi.find, payload)) as PersonalAccidentQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handlePersonalAccidentQuoteSendEmail({ payload }: SagaPayload<PersonalAccidentQuoteSendEmailPayload>) {
  yield call(PersonalAccidentQuoteApi.sendEmail, payload);
}

export default function* () {
  yield takeLatest(personalAccidentQuoteFind, handlePersonalAccidentQuoteFind);
  yield takeLatest(personalAccidentQuoteSendEmail, handlePersonalAccidentQuoteSendEmail);
}
